import * as React from 'react'
import classes from './styles.module.css'
import clsx from 'clsx'

interface GradientTextProps {
  text: string
  customStyle?: React.CSSProperties
  type?: 'primary' | 'secondary'
}
export default function GradientText({text, customStyle, type = 'primary'}: GradientTextProps) {
  return (
    <h4 className={clsx(classes.container, classes[`${type}Container`])}>
      {type === 'primary' ? (
        <span className={classes.gradientText} style={customStyle}>
          {text}
        </span>
      ) : (
        <span style={customStyle}>{text}</span>
      )}
    </h4>
  )
}
